import { render, staticRenderFns } from "./NotificationPhonePreview.vue?vue&type=template&id=1e809e16&scoped=true&"
import script from "./NotificationPhonePreview.vue?vue&type=script&lang=js&"
export * from "./NotificationPhonePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e809e16",
  null
  
)

export default component.exports